module.exports = __webpack_public_path__ + "static/media/Star.847d52fe.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/About/NewTimeline/assets/Star.svg
// module id = 265
// module chunks = 0